import axios from '../../helpers/axios'
import { logError } from '../../services';
import { IDropdownResponse, IPlanDependencyDropdownResponse } from '../../models';

const base = `/api/field-walkthrough-location-management/lookup`
export const getFieldWalkthroughLocationManagementLocations = async (isActive: boolean): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`${base}/locations`, {params: {
      isActive
    }});

    return data;
  } catch (error: any) {
    logError(error, 'getFieldWalkthroughLocationManagementLocations failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getFieldWalkthroughLocationManagementPlanDependencies = async (): Promise<IPlanDependencyDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`${base}/plan-dependencies`);

    return data;
  } catch (error: any) {
    logError(error, 'getFieldWalkthroughLocationManagementPlanDependencies failed');
    return Promise.reject(error?.response?.data);
  }
};